import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { MarketplaceHeroSlideTextBlockConfig } from '@front-platform/content-builder';
import { marketplaceHeroSlideTextBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';
export interface MarketplaceHeroSlideTextBlockRuntimeConfig {}

export type MarketplaceHeroSlideTextBlockConfigInput = Partial<
  Omit<MarketplaceHeroSlideTextBlockConfig, keyof MarketplaceHeroSlideTextBlockRuntimeConfig> &
    MarketplaceHeroSlideTextBlockRuntimeConfig
>;
export type MarketplaceHeroSlideTextBlockResolvedConfig = Omit<
  MarketplaceHeroSlideTextBlockConfig,
  keyof MarketplaceHeroSlideTextBlockRuntimeConfig
> &
  Partial<MarketplaceHeroSlideTextBlockRuntimeConfig>;
export interface MarketplaceHeroSlideTextBlockContract extends ConfigComponentContract<
  MarketplaceHeroSlideTextBlockConfigInput,
  MarketplaceHeroSlideTextBlockResolvedConfig
> {}

@Component({
  selector: 'app-marketplace-hero-slide-text-block',
  templateUrl: './marketplace-hero-slide-text-block.component.html',
  standalone: false,
})
export class MarketplaceHeroSlideTextBlockComponent implements MarketplaceHeroSlideTextBlockContract {
  readonly config = input<MarketplaceHeroSlideTextBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    MarketplaceHeroSlideTextBlockConfig,
    MarketplaceHeroSlideTextBlockRuntimeConfig
  >(marketplaceHeroSlideTextBlockResolveConfig, () => ({ config: this.config() }));
  get text(): string {
    return this.resolvedConfig()['text'] as unknown as string;
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(MarketplaceHeroSlideTextBlockComponent, {
  'keyAliases': {},
});
